// extracted by mini-css-extract-plugin
module.exports = {"tagStyle":"ExtractorFilter_tagStyle_3D3MJ"};